import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import * as S from './styled';

const getOptions = (items, { getValue, getLabel }) =>
  items.map((item) => ({
    value: getValue(item),
    label: getLabel(item),
  }));

// TODO: make reusable select for many containers/components, there are so many of them now...
const FormSelect = ({
  items,
  value,
  onChange,
  filterOptions,
  getValue,
  getLabel,
  ...props
}) => {
  const options = useMemo(
    () => filterOptions(getOptions(items, { getValue, getLabel })),
    [items, filterOptions]
  );
  const selectedOption = options.find((option) => option.value === value);
  const handleChange = useCallback((option) => {
    onChange(option.value);
  }, []);

  return (
    <S.Select
      menuShouldScrollIntoView
      classNamePrefix="rs"
      position="relative"
      options={options}
      isMulti={false}
      value={selectedOption}
      onChange={handleChange}
      components={{
        DropdownIndicator: null,
      }}
      {...props}
    />
  );
};

FormSelect.defaultProps = {
  isLoading: false,
  isDisabled: false,
  filterOptions: (items) => items,
  getValue: (item) => item.value,
  getLabel: (item) => item.label,
};

FormSelect.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  filterOptions: PropTypes.func,
  getValue: PropTypes.func,
  getLabel: PropTypes.func,
};

export default FormSelect;
